import { Fragment } from 'react';

function CategoryNav({ categories, active, onChange }) {
  return (
    <section className="category-navigation" id="collections">
      <div className="category-links">
        {categories.map((category, index) => (
          <Fragment key={category.slug}>
            <button
              className={`category-button ${active === category.slug ? 'active' : ''}`}
              onClick={() => onChange(category.slug)}
            >
              {category.name}
            </button>
            {index < categories.length - 1 && (
              <span className="category-divider">|</span>
            )}
          </Fragment>
        ))}
      </div>
    </section>
  );
}

export default CategoryNav;
